import React, { useEffect, useState} from "react";
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import Link from '@material-ui/core/Link';
import LinearProgress from '@material-ui/core/LinearProgress';
import Paper from '@material-ui/core/Paper';
import BigNumber from "bignumber.js";
import { FormattedMessage } from 'react-intl';
import Countdown, { zeroPad } from 'react-countdown';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';


const useStyles = makeStyles((theme) => ({
  countDownRendererRoot: {
    display: 'table',
    flexWrap: 'wrap',
    margin: 'auto',
    padding: theme.spacing(0, 2),
    borderCollapse: "separate",
    // borderSpacing: theme.spacing(1) + "px 0",
    '& > .main': {
      display: 'table-cell',
      verticalAlign: "middle",
      width: theme.spacing(8),
      height: theme.spacing(8),
    },
    '& > .sub': {
      display: 'table-cell',
      verticalAlign: "middle",
      width: theme.spacing(4),
      height: theme.spacing(8),
    },
  },
  countDownRendererFooterRoot: {
    display: 'table',
    flexWrap: 'wrap',
    margin: 'auto',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(0, 2),
    },
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(0, 5),
    },
    borderCollapse: "separate",
    // borderSpacing: theme.spacing(1) + "px 0",
    '& > .main': {
      display: 'table-cell',
      verticalAlign: "middle",
      width: theme.spacing(8),
      height: theme.spacing(4),
      [theme.breakpoints.down('sm')]: {
        fontSize: "7px"
      },
      [theme.breakpoints.up('sm')]: {
        fontSize: "0.75"
      },
    },
    '& > .sub': {
      display: 'table-cell',
      verticalAlign: "middle",
      width: theme.spacing(4),
      height: theme.spacing(4),
    },
  },
  countDownOuter: {
    padding: theme.spacing(4)
  },
  title: {
  },
  subTitle: {
    display: 'table',
    margin: "auto"
  },
  progress: {
    width:"80%",
    margin: theme.spacing(4,"auto"),
    padding: theme.spacing(2)
  },
}));

const TokenSalesInfo = ({ readSales, config }) => {
  const openTime = 1643846400000;
  const closeTime = 1659311999000;
  const unlockTime = 1635638400000;
  const [address, setAddress] = useState()
  const [progress, setProgress] = useState(30)
  const [cap, setCap] = useState("10000000")
  // const [goal, setGoal] = useState("30000000")
  const [openingTime, setdOpeningTime] = useState(moment(new Date(openTime)).utc().format('lll'))
  const [closingTime, setClosingTime] = useState(moment(new Date(closeTime)).utc().format('lll'))
  // const [tokenUnlockTime, setTokenUnlockTime] = useState(moment(new Date(1635638400000)).utc().format('lll'))
  const [rate, setRate] = useState("100")
  const [title, setTitle] = useState("")
  const [countdownDate, setCountdownDate] = useState(Number.MAX_SAFE_INTEGER)
  const classes = useStyles();

  const setState = async () => {
    if (readSales && address != readSales._address) {
      setAddress(readSales._address);

      if (Date.now() < openTime) {
        setTitle("App.TokenSalesInfo.BeforeSale")
      } else if (Date.now() < closeTime) {
        setTitle("App.TokenSalesInfo.OnSale")
      } else if (Date.now() < unlockTime) {
        setTitle("App.TokenSalesInfo.Locked")
      }

      setCap(new BigNumber(await readSales.methods.cap().call()).div(new BigNumber(10).pow(18)).toString(10));
      // setGoal(new BigNumber(await readSales.methods.goal().call()).div(new BigNumber(10).pow(18)).toString(10));
      const _openingTime = await readSales.methods.openingTime().call() * 1000
      setdOpeningTime(new Date(_openingTime).toLocaleString());
      const _closingTime = await readSales.methods.closingTime().call() * 1000
      setClosingTime(new Date(_closingTime).toLocaleString());
      // const _tokenUnlockTime = await readSales.methods.tokenUnlockTime().call() * 1000
      // setTokenUnlockTime(new Date(_tokenUnlockTime).toLocaleString());
      setRate(new BigNumber(await readSales.methods.rate().call()).div(new BigNumber(10).pow(18)).toString(10));

    }
  }
  useEffect(() => {
    setState()
  })

  return (
    <Container>
      <Typography component="h1" variant="h5">
        PreSale Information
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={5}>
          <FormattedMessage id="App.TokenSalesInfo.ContractAddress" />
        </Grid>
        <Grid item xs={12} sm={7} style={{fontSize:'0.65rem',lineHeight:'20px'}}>
          <LinearProgress hidden={address !== undefined} />
          {address !== undefined &&
            <Link style={{ wordBreak: "break-all" }}  href={config.etherscan.getAddressUrl(address)} target="_blank">
              {address}
            </Link>
          }
        </Grid>
        <Grid item xs={12} sm={5}>
          <FormattedMessage id="App.TokenSalesInfo.Cap" />
        </Grid>
        <Grid item xs={12} sm={7}>
          <LinearProgress hidden={cap !== undefined} />
          {cap ? cap + " EAR" : ""}
        </Grid>
        {/* <Grid item xs={12} sm={6}>
          <FormattedMessage id="App.TokenSalesInfo.Goal" />
        </Grid>
        <Grid item xs={12} sm={6}>
          <LinearProgress hidden={goal !== undefined} />
          {goal ? goal + " EAR" : ""}
        </Grid> */}
        <Grid item xs={12} sm={5}>
          <FormattedMessage id="App.TokenSalesInfo.OpeningTime" />
        </Grid>
        <Grid item xs={12} sm={7}>
          <LinearProgress hidden={openingTime !== undefined} />
          {openingTime}
        </Grid>
        <Grid item xs={12} sm={5}>
          <FormattedMessage id="App.TokenSalesInfo.ClosingTime" />
        </Grid>
        <Grid item xs={12} sm={7}>
          <LinearProgress hidden={closingTime !== undefined} />
          {closingTime}
        </Grid>
        {/* <Grid item xs={12} sm={6}>
          <FormattedMessage id="App.TokenSalesInfo.TokenUnlockTime" />
        </Grid>
        <Grid item xs={12} sm={6}>
          <LinearProgress hidden={tokenUnlockTime !== undefined} />
          {tokenUnlockTime}
        </Grid> */}
        <Grid item xs={12} sm={5}>
          <FormattedMessage id="App.TokenSalesInfo.Rate" />
        </Grid>
        <Grid item xs={12} sm={7}>
          <LinearProgress hidden={rate !== undefined} />
          {rate ? rate/100+" EAR = $0.01":""}
        </Grid>
      </Grid>
    </Container>
  );
}
export default TokenSalesInfo;
